import * as React from "react";
import { useTranslation } from "react-i18next";
import { InputOptionalInfo, FormikFormGroup } from "components/common";
const DescriptionFormGroup = ({ wrapperClassName = void 0, labelClassName = void 0 }) => {
  const { t } = useTranslation("enterprise_search");
  return /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "description",
      label: /* @__PURE__ */ React.createElement(React.Fragment, null, t("description_form_group.description"), " ", /* @__PURE__ */ React.createElement(InputOptionalInfo, null)),
      type: "textarea",
      labelClassName,
      wrapperClassName,
      help: t("description_form_group.help")
    }
  );
};
export default DescriptionFormGroup;
